<script lang="ts">
    import PaddingX from "./PaddingX.svelte";
    import { cn } from "~/utils";

    export let title: string;
    export let subtitle: string | undefined;
</script>

<PaddingX class={cn("w-full", $$restProps.class)}>
    <h1 class="title">
        {title}
    </h1>
    {#if subtitle != null}
        <h2 class="subtitle">
            {subtitle}
        </h2>
    {/if}
</PaddingX>

<style>
    .title {
        font-size: clamp(24px, calc(28px + 1vw), 42px);
        font-weight: 600;
        color: var(--secondary-color);
    }

    .subtitle {
        display: block;
        font-size: clamp(14px, calc(16px + 1vw), 20px);
        color: var(--secondary-color-50);
    }
</style>
